import React, { Component } from 'react';
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';

const URL = Constants.URL.root+'/wp-json/wp/v2/hanging?_embed';
class Hanging extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoaded: false,
			error: null,
			runAPI: false
		}
	}

	fetchHanging = () => {
		this.setState({ runAPI: true });
		var self = this;
		fetch(URL)
		.then(response => {
			if (!response.ok) {
				throw Error('Network request failed.')
			}
			return response;
		})
		.then(data => data.json())
		.then(data => {
			//console.log(data);
			self.dispatchHangingData(data);
			self.selectHanging(data[0])
			self.setState({ isLoaded: true });
		}, (ex) => {
			self.setState({ isLoaded: true });
			self.setState({ error: ex.message });
			self.fetchHanging();
		})
	}

	dispatchHangingData(HangingData) {
		const data = HangingData;
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				hanging: data
			}
		})
	}

	selectHanging = (hanging) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedHanging: hanging
			}
		})
	}

	componentDidUpdate(prevProps, prevState) {
		if ('hanging' === this.props.selectedTab && !this.state.runAPI) {
			this.fetchHanging();
		}
	}

	render() {
		const { isLoaded, error } = this.state;
		const { selectedHanging, hanging } = this.props;
		if (error) {
			return <div className="alert alert-danger">{error}</div>;
		} else {
			return (
				<div className="frm_mn_box">
					{isLoaded ?
						<div className="row">
							<div className="col-md-10 col-sm-12">
								<div className="row">
									{hanging.map( (hang) =>
										<div className="col-sm-4" key={hang.get('id')} onClick={this.selectHanging.bind(this, hang)} style={{ cursor: 'pointer' }}>
											<strong style={{ marginBottom: 10, display: 'block', color: '#000'}}>{hang.getIn(['title', 'rendered'])}</strong>
											<img className={selectedHanging.get('id') === hang.get('id') ? "selectedImageFrameNew" : ''} src={hang.getIn(['acf', 'hanging_tab_image', 'url'])} alt={hang.getIn(['title', 'rendered'])} />
										</div>
									)}
								</div>
							</div>
						</div>
					: <Loader/>}
				</div>
			);
		}
	}
}

export default Hanging;